import React, { createContext, useState, useContext } from "react";

const PanelContext = createContext<{
  isOpen: boolean;
  togglePanel: () => void;
}>({
  isOpen: false,
  togglePanel: () => {},
});

export const PanelProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const togglePanel = () => {
    setIsOpen((prev) => !prev);
  };
  return (
    <PanelContext.Provider value={{ isOpen, togglePanel }}>
      {children}
    </PanelContext.Provider>
  );
};

export const usePanel = () => useContext(PanelContext);
